import PhotoSwipe from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js';

const leftArrowSVGString = `
<svg viewBox="0 0 45.5 45.5">
  <defs>
    <style>
      .banner-left-cls-1 {
        fill: #000;
        opacity: .15;
      }

      .banner-left-cls-2 {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
      }
    </style>
  </defs>
  <circle class="banner-left-cls-1" cx="22.75" cy="22.75" r="22.5"/>
  <polyline class="banner-left-cls-2" points="26.16 12.75 16.16 22.75 26.16 32.75"/>
</svg>
`

const rightArrowSVGString = `
<svg viewBox="0 0 45.5 45.5">
  <defs>
    <style>
      .banner-right-cls-1 {
        fill: #000;
        opacity: .15;
      }

      .banner-right-cls-2 {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
      }
    </style>
  </defs>
  <circle class="banner-right-cls-1" cx="22.75" cy="22.75" r="22.5"/>
  <polyline class="banner-right-cls-2" points="19.34 32.75 29.34 22.75 19.34 12.75"/>
</svg>

`
let imageThumList = []
const closeSvgString = `
<svg width="35" height="35" class="icon icon--close" viewBox="0 0 35.5 35.5">
  <defs>
    <style>
      .close-cls-1 {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
      }

      .close-cls-2 {
        opacity: .15;
      }
    </style>
  </defs>
  <circle class="close-cls-2" cx="17.75" cy="17.75" r="17.5"/>
  <g>
    <line class="close-cls-1" x1="23.12" y1="23.12" x2="12.37" y2="12.37"/>
    <line class="close-cls-1" x1="12.37" y1="23.12" x2="23.12" y2="12.37"/>
  </g>
</svg>`
let pswpSlider = null
document.addEventListener('DOMContentLoaded', function () {

    // 切换图片
    const goToSlide = (index) => {
        const li = document.querySelectorAll('.pswp__thumbnails li');
        li.forEach(li => {
            li.classList.remove('is-selected');
        });
        li[index].classList.add('is-selected');
        pswpSlider.goTo(index);
    }
    const getWidthHeight = (img) => {
        let width = img.getAttribute('width');
        let height = img.getAttribute('height');
        let maxWidth = window.innerWidth * 0.66;
        if (width > maxWidth) {
            height = maxWidth / (width / height);
            width = maxWidth;
        }
        return { width, height }
    }
    // 初始化轮播
    const initSlider = () => {
        let options = {
            arrowPrevSVG: leftArrowSVGString,
            arrowNextSVG: rightArrowSVGString,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            closeSVG: closeSvgString,
            dataSource: [],
            tapToClose: true,
            showHideAnimationType: 'none',
            padding: { top: 38, bottom: 132 },
            index: 0
        };
        const imgList = document.querySelectorAll('.product__imageViewBox-wrapper img');
        imgList.forEach((img, index) => {
            options.dataSource.push({
                src: img.src,
                ...getWidthHeight(img),
                // width: img.getAttribute('width'),
                // height: img.getAttribute('height'),
                alt: img.alt,
            });
        });
        console.log(options.dataSource);
        imageThumList = options.dataSource;
        pswpSlider = new PhotoSwipe(options);
        // options.index = Number(document.querySelector('.product__media-item.is-selected').dataset.originalPosition);
        bindEvent();
        pswpSlider.init();
        pswpSlider.goTo(Number(document.querySelector('.product__media-item.is-selected').dataset.originalPosition))
    }

    // 绑定事件
    const bindEvent = () => {
        pswpSlider.on('change', function (evt) {
            if (document.querySelector('.pswp__thumbnails li.is-selected')) {
                if (pswpSlider.currIndex === Number(document.querySelector('.pswp__thumbnails li.is-selected').dataset.original)) {
                    return
                } else {
                    goToSlide(pswpSlider.currIndex)
                }
            }
        })
        pswpSlider.on('loadComplete', function (evt) {
            if (document.querySelector('#photoswipe-thumbnails').childNodes.length == 0) {
                let li = '';
                for (let i = 0; i < imageThumList.length; i++) {
                    li += `<li data-original="${i}" class="${i === pswpSlider.currIndex ? 'is-selected' : ''}">
                        <img src="${imageThumList[i].src}" alt="${imageThumList[i].alt}" width="60" height="auto">
                    </li>`;
                }
                let pagination = `
                            <ul class="pswp__thumbnails">
                                ${li}
                            </ul>
                        `;
                document.querySelector('#photoswipe-thumbnails').innerHTML += pagination;
                const paginationUl = document.querySelector('.pswp__thumbnails');
                paginationUl.addEventListener('click', function (event) {
                    if (event.target.tagName === 'IMG') {
                        event.stopPropagation();
                        const index = event.target.parentNode.dataset.original;
                        goToSlide(Number(index))
                    }
                })
            }

        })
        pswpSlider.on('close', function () {
            document.querySelector('#photoswipe-thumbnails').innerHTML = '';
        })

    }
    document.getElementById('magnifyIcon').onclick = () => {
        initSlider();
    }
})